import { AbstractModel, FileData } from '@uzurv/core';
import { autoserialize, autoserializeAs, inheritSerialization } from 'cerialize';

@inheritSerialization(AbstractModel)
export class RiderSignature extends AbstractModel {
  @autoserialize
  riderId: number;

  @autoserialize
  active: boolean;

  @autoserializeAs(FileData)
  file: FileData;
}
